import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findMessage= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-cluster/v1/message/findAll?`+params,
        method: 'GET'
    })
}

export const addMessage = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/message/insertMessage`,
        method: 'POST',
        data: data
    })
}
export const editMessage = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/message/updateMessage`,
        method: 'PUT',
        data: data
    })
}
export const delMessage = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-cluster/v1/message/deleteMessage/${temp}`,
        method: 'DELETE'
    })
}

export const sendMessage = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/message/sendMessage/${id}`,
        method: 'GET'
    })
}
export const findCluster= () => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/cluster/findAll`,
        method: 'GET'
    })
}
